import React from 'react';
import SafeIcon from '../common/SafeIcon';
import BlogComments from './BlogComments';

export default function LeaderStoryLayout({ post }) {
  return (
    <article className="max-w-7xl mx-auto px-6 py-12 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        
        {/* Left Column: Fixed Portrait & Info */}
        <div className="lg:col-span-5 relative">
          <div className="lg:sticky lg:top-32">
            <div className="relative aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl border border-[var(--border-subtle)] mb-8">
              <img src={post.image} alt={post.author} className="w-full h-full object-cover" />
              <div className="absolute top-4 left-4">
                <span className="px-4 py-1.5 gfi-gradient-bg text-brand-navy rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg">
                  {post.category}
                </span>
              </div>
            </div>

            <div className="hidden lg:block bg-[var(--bg-surface)] p-8 rounded-3xl border border-[var(--border-subtle)] shadow-sm">
              <SafeIcon name="Quote" className="w-10 h-10 text-brand-gold mb-6 opacity-50" />
              <h2 className="text-3xl font-black text-[var(--text-main)] uppercase italic tracking-tighter leading-tight mb-6">
                {post.quote}
              </h2>
              <div className="pt-6 border-t border-[var(--border-subtle)]">
                <p className="text-sm font-black text-[var(--text-main)] uppercase tracking-[0.2em]">{post.author}</p>
                <p className="text-[10px] font-bold text-[var(--text-secondary)] uppercase tracking-widest mt-1">{post.role}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Story Content */}
        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="mb-12">
            <h1 className="text-5xl md:text-7xl font-black text-[var(--text-main)] uppercase italic tracking-tighter leading-[0.9] mb-6">
              {post.title}
            </h1>
            <p className="text-xs font-black text-[var(--text-secondary)] uppercase tracking-[0.3em] flex items-center gap-2">
              <SafeIcon name="Calendar" className="w-4 h-4" /> Publicado el {post.date}
            </p>
          </div>

          <div className="lg:hidden bg-[var(--bg-surface)] p-6 md:p-8 rounded-3xl border border-[var(--border-subtle)] shadow-sm mb-12">
            <SafeIcon name="Quote" className="w-8 h-8 text-brand-gold mb-4 opacity-50" />
            <h2 className="text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tighter leading-tight mb-6">
              {post.quote}
            </h2>
            <div className="pt-4 border-t border-[var(--border-subtle)]">
              <p className="text-xs font-black text-[var(--text-main)] uppercase tracking-[0.2em]">{post.author}</p>
              <p className="text-[9px] font-bold text-[var(--text-secondary)] uppercase tracking-widest mt-1">{post.role}</p>
            </div>
          </div>

          <div 
            className="prose prose-lg prose-slate max-w-none 
              prose-p:text-[var(--text-main)]/80 prose-p:leading-relaxed prose-p:font-medium prose-p:mb-8 prose-p:text-lg
              prose-strong:text-[var(--text-main)] prose-strong:font-black"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <BlogComments />
        </div>

      </div>
    </article>
  );
}